var React = require('react');

var Items = require('./items.js');
var Form = require('./form.js');
var css = require('./module.scss');

/**
 * 使用方法：
 * <Pagination page={this.state.currentPage}
        size={10}
        len={3}
        total={51}
        btnSize='sm'
        onPageChange={this.onPageChange}
    />
 *
 * page: 当前页
 * size: 每页数据总数
 * total: 数据总量
 * btnSize: 不设置时为default，可设置为sm, lg, 影响高度
 * onPageChange: 点击翻页的回调函数
 */

var Pagination = React.createClass({

    onPageChange: function(page) {
        this.props.onPageChange && this.props.onPageChange(page);
    },

    render: function() {
        if (this.props.total === undefined) {
            window.console.error('total count is undefined');
            return null;
        }

        var cls = ['fp-pagination', this.props.className];
        var min = 1;
        var max = Math.ceil(this.props.total / this.props.size);

        return (
            <div className={cls.join(' ')}>
                <Items
                    page={this.props.page}
                    size={this.props.size}
                    min={min}
                    max={max}
                    len={this.props.len}
                    btnSize={this.props.btnSize}
                    onPageChange={this.onPageChange}
                />
                <Form
                    page={this.props.page}
                    size={this.props.size}
                    min={min}
                    max={max}
                    btnSize={this.props.btnSize}
                    total={this.props.total}
                    onPageChange={this.onPageChange}
                />
            </div>
        );
    }

});

module.exports = Pagination;



// WEBPACK FOOTER //
// ./component/pagination/index.js